import React from 'react'
import { Field as FormikField, ErrorMessage } from 'formik'
import { TextField } from 'formik-material-ui'
import styled from 'styled-components'
import { FieldT, FieldVariantEnum } from './types'

interface Props {
  field: FieldT
  variant?: FieldVariantEnum
}

const StyledField = styled(FormikField)``

const RichtextField: React.FC<Props> = ({ field }) => {
  return (
    <>
      <StyledField
        key={field.name}
        name={field.name}
        label={field.title}
        rows='5'
        variant='outlined'
        multiline
        fullWidth
        InputLabelProps={{ shrink: true }}
        component={TextField}
      />
      <ErrorMessage name={field.name} />
    </>
  )
}

export default RichtextField
